
let host;
if(location.protocol == 'http:'){
	host = 'http:'
}else{
	host = 'https:'
}
let local = host+"//dj.gxsentu.net/people/"
let serve = host+"//dj.gxsentu.net/people/"

let url_config = {
	baseUrl:process.env.NODE_ENV === 'development'?local:serve,
	uploadFile:process.env.NODE_ENV === 'development'?local+'?c=d_three_api&m=uploadFile'
		:serve+'?c=d_two_api&m=uploadFile',
	uploadImg:process.env.NODE_ENV === 'development'?local+'?c=d_three_api&m=uploadImg'
		:serve+'?c=d_two_api&m=uploadImg'
}

export default url_config

